<div class="outside-wrapper" *ngIf="alerts.length">
  <div *ngIf="alert && alert.route && alert.route.length" class="inner accent-color">
    <a (click)="gaTrack(alert)" [routerLink]="alert.route">{{alert.text}}</a>
  </div>
  <div *ngIf="alert && (!alert.route || !alert.route.length)" class="inner accent-color">
    <span>{{alert.text}}</span>
  </div>
</div>